import { render, staticRenderFns } from "./DadosGerais.vue?vue&type=template&id=7ab97ac2&scoped=true"
import script from "./DadosGerais.vue?vue&type=script&lang=js"
export * from "./DadosGerais.vue?vue&type=script&lang=js"
import style0 from "./DadosGerais.vue?vue&type=style&index=0&id=7ab97ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab97ac2",
  null
  
)

export default component.exports